import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Row, Col } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCamera, faTimesCircle } from '@fortawesome/free-solid-svg-icons';
import Lightbox from 'lightbox-react';
import Translate from '../common/Translate';
import 'lightbox-react/style.css';

const DisplayElement = ({
  id,
  image,
  element,
  displayValue,
  handleDeleteBlock,
  handleUploadImage,
  type,
  handleUpdateDamage,
}) => {
  const [popedUp, setPopup] = useState(false);

  const RenderLabel = () => {
    switch (type) {
      case 'multiple_photos':
        return (
          <div className="damage-text pt-4">
            <span className="text-primary" data-cy={`${element}damage`}>
              {displayValue || '-'}
            </span>
          </div>
        );

      default:
        return (
          <div className="damage-text">
            <p className="text-primary h6 damage-text" data-cy={element}>
              <Translate code={element} />
            </p>
            <span className="text-secondary" data-cy={`${element}damage`}>
              {displayValue || '-'}
            </span>
          </div>
        );
    }
  };

  const togglePopup = () => {
    setPopup(!popedUp);
  };

  return (
    <Col xs="12" md="6" lg="6" key={id}>
      <Row className="single-damage-image">
        <Col xs="5" className="slide-damage-wrapper">
          {popedUp && image && <Lightbox mainSrc={image} onCloseRequest={togglePopup} />}
          {(image && (
            <div className="damage-image">
              <img src={image} alt="" onClick={() => togglePopup(image)} onKeyDown={() => {}} role="presentation" />
            </div>
          )) || (
            <label htmlFor={`upload_camera_${element}_element`} className="button-camera circle upload-damage-image">
              <FontAwesomeIcon icon={faCamera} />
              <input
                type="file"
                id={`upload_camera_${element}_element`}
                accept="image/*"
                capture="camera"
                onChange={(e) => handleUploadImage(e)}
                data-cy={`${element}_camera`}
              />
            </label>
          )}
        </Col>
        <Col xs="7">
          <RenderLabel />
          <FontAwesomeIcon
            icon={faTimesCircle}
            onClick={handleDeleteBlock}
            className="damage-delete-btn"
            data-cy={`${element}_deleteBlock`}
            size="2x"
          />
        </Col>
      </Row>
      <p
        className="modify-btn text-right"
        onClick={() => handleUpdateDamage(id)}
        onKeyDown={() => {}}
        role="presentation"
      >
        <Translate code="modify" />
      </p>
    </Col>
  );
};

DisplayElement.propTypes = {
  id: PropTypes.string.isRequired,
  image: PropTypes.shape(),
  element: PropTypes.string.isRequired,
  displayValue: PropTypes.string.isRequired,
  handleDeleteBlock: PropTypes.func.isRequired,
  handleUploadImage: PropTypes.func.isRequired,
  type: PropTypes.string,
  handleUpdateDamage: PropTypes.func.isRequired,
};

DisplayElement.defaultProps = {
  image: null,
  type: undefined,
};
export default DisplayElement;
